import React, { useState } from "react";
import { Typography, Container, Grid } from "@mui/material";
import styles from "../style.module.scss";
import textStyles from "./style.module.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Card, CardContent, Avatar, Rating } from "@mui/material";
import SchoolGirl from "@assets/fineModels/girlDog.png";
import userImage from "@assets/placeholder.png";
import forestGirl from "@assets/forestGirl.png";
import biker from "@assets/biker.png";
import villian from "@assets/villian.png";
import motherDay from "@assets/gallery/motherDay.png";
import boyWriting from "@assets/gallery/boyWriting.png";
import boyAndGirl from "@assets/fineModels/boyAndGirl.png";
import investigating from "@assets/fineModels/investigating.png";
import laptop from "@assets/fineModels/laptop.png";
import creator from "@assets/fineModels/creator.png";
import superHeroes from "@assets/fineModels/superHeroes.png";
import painter from "@assets/fineModels/Painter.png";
import familyDay from "@assets/fineModels/familyDay.png";
import power from "@assets/fineModels/Power.png";
// Import Swiper styles

import video from "@assets/home/hero/particles.mp4";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";

const Testimonials = ({ review, rating, userName }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  return (
    <>
      <section className="testimonials" style={{}}>
        <div style={{ textAlign: "center" }}>
          <Typography
            variant="h2"
            gutterBottom
            className={styles.feature_heading}
          >
            Testimonials
          </Typography>
        </div>

        <Grid container justifyContent="center" spacing={2} padding={10}>
          <Swiper
            style={{
              "--swiper-navigation-color": "#fff",
              "--swiper-pagination-color": "#fff",
            }}
            spaceBetween={10}
            navigation={true}
            thumbs={{ swiper: thumbsSwiper }}
            modules={[FreeMode, Navigation, Thumbs]}
            className="mySwiper2"
          >
            <SwiperSlide>
              <Grid container spacing={2} style={{ justifyContent: "center" }}>
                <Grid item lg={3}>
                  <Card
                    variant="outlined"
                    style={{ background: "none", position: "relative" }}
                  >
                    {/* Background */}
                    <div
                      style={{
                        backgroundColor: "white",
                        height: "300px",
                        opacity: "0.08",
                      }}
                    ></div>
                    {/* Card Content */}
                    <CardContent
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                      }}
                    >
                      <Grid container spacing={2} alignItems="center">
                        {/* Testimonial */}
                        <Grid item xs={12}>
                          <Typography variant="body1" sx={{ color: "white" }}>
                            UE Comix is a game-changer! Their AI tools are like
                            having a super-powered artistic partner.
                          </Typography>
                        </Grid>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            textAlign: "center",
                            alignItems: "center",
                            width: "100%",
                            marginTop: "2rem",
                          }}
                        >
                          {/* Rating */}
                          <Grid item xs={12}>
                            <Rating
                              name="testimonial-rating"
                              value={4}
                              precision={1}
                              readOnly
                            />
                          </Grid>
                          {/* User Image */}
                          <Grid item xs={12} md={12}>
                            <Avatar
                              alt={userName}
                              src={userImage}
                              sx={{ width: 100, height: 100 }}
                            />
                          </Grid>
                          {/* User Name */}
                          <Grid item xs={12} md={12}>
                            <Typography
                              variant="subtitle1"
                              gutterBottom
                              sx={{ color: "white", marginTop: "1rem" }}
                            >
                              [Industry Pro]
                            </Typography>
                          </Grid>
                        </div>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item lg={3}>
                  <Card
                    variant="outlined"
                    style={{ background: "none", position: "relative" }}
                  >
                    {/* Background */}
                    <div
                      style={{
                        backgroundColor: "white",
                        height: "300px",
                        opacity: "0.08",
                      }}
                    ></div>
                    {/* Card Content */}
                    <CardContent
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                      }}
                    >
                      <Grid container spacing={2} alignItems="center">
                        {/* Testimonial */}
                        <Grid item xs={12}>
                          <Typography variant="body1" sx={{ color: "white" }}>
                            Finally, a platform that unleashes my craziest comic
                            visions without barriers!
                          </Typography>
                        </Grid>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            textAlign: "center",
                            alignItems: "center",
                            width: "100%",
                            marginTop: "2rem",
                          }}
                        >
                          {/* Rating */}
                          <Grid item xs={12}>
                            <Rating
                              name="testimonial-rating"
                              value={4}
                              precision={1}
                              readOnly
                            />
                          </Grid>
                          {/* User Image */}
                          <Grid item xs={12} md={12}>
                            <Avatar
                              alt={userName}
                              src={userImage}
                              sx={{ width: 100, height: 100 }}
                            />
                          </Grid>
                          {/* User Name */}
                          <Grid item xs={12} md={12}>
                            <Typography
                              variant="subtitle1"
                              gutterBottom
                              sx={{ color: "white", marginTop: "1rem" }}
                            >
                              [Creator]
                            </Typography>
                          </Grid>
                        </div>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </SwiperSlide>
            <SwiperSlide>
              <Grid container spacing={2} style={{ justifyContent: "center" }}>
                <Grid item lg={3}>
                  <Card
                    variant="outlined"
                    style={{ background: "none", position: "relative" }}
                  >
                    {/* Background */}
                    <div
                      style={{
                        backgroundColor: "white",
                        height: "400px",
                        opacity: "0.08",
                      }}
                    ></div>
                    {/* Card Content */}
                    <CardContent
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                      }}
                    >
                      <Grid container spacing={2} alignItems="center">
                        {/* Testimonial */}
                        <Grid item xs={12}>
                          <Typography variant="body1" sx={{ color: "white" }}>
                            I'm amazed by the image generation ability of this
                            app! The AI technology it employs is truly
                            groundbreaking. I've been able to create stunning
                            images effortlessly, thanks to its intuitive
                            interface and powerful features. It's like having a
                            professional designer at my fingertips. Highly
                            recommended!
                          </Typography>
                        </Grid>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            textAlign: "center",
                            alignItems: "center",
                            width: "100%",
                            marginTop: "2rem",
                          }}
                        >
                          {/* Rating */}
                          <Grid item xs={12}>
                            <Rating
                              name="testimonial-rating"
                              value={4}
                              precision={1}
                              readOnly
                            />
                          </Grid>
                          {/* User Image */}
                          <Grid item xs={12} md={12}>
                            <Avatar
                              alt={userName}
                              src={userImage}
                              sx={{ width: 100, height: 100 }}
                            />
                          </Grid>
                          {/* User Name */}
                          <Grid item xs={12} md={12}>
                            <Typography
                              variant="subtitle1"
                              gutterBottom
                              sx={{ color: "white" }}
                            >
                              Shazil Saleem
                            </Typography>
                          </Grid>
                        </div>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item lg={3}>
                  <Card
                    variant="outlined"
                    style={{ background: "none", position: "relative" }}
                  >
                    {/* Background */}
                    <div
                      style={{
                        backgroundColor: "white",
                        height: "400px",
                        opacity: "0.08",
                      }}
                    ></div>
                    {/* Card Content */}
                    <CardContent
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                      }}
                    >
                      <Grid container spacing={2} alignItems="center">
                        {/* Testimonial */}
                        <Grid item xs={12}>
                          <Typography variant="body1" sx={{ color: "white" }}>
                            I'm amazed by the image generation ability of this
                            app! The AI technology it employs is truly
                            groundbreaking. I've been able to create stunning
                            images effortlessly, thanks to its intuitive
                            interface and powerful features. It's like having a
                            professional designer at my fingertips. Highly
                            recommended!
                          </Typography>
                        </Grid>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            textAlign: "center",
                            alignItems: "center",
                            width: "100%",
                            marginTop: "2rem",
                          }}
                        >
                          {/* Rating */}
                          <Grid item xs={12}>
                            <Rating
                              name="testimonial-rating"
                              value={4}
                              precision={1}
                              readOnly
                            />
                          </Grid>
                          {/* User Image */}
                          <Grid item xs={12} md={12}>
                            <Avatar
                              alt={userName}
                              src={userImage}
                              sx={{ width: 100, height: 100 }}
                            />
                          </Grid>
                          {/* User Name */}
                          <Grid item xs={12} md={12}>
                            <Typography
                              variant="subtitle1"
                              gutterBottom
                              sx={{ color: "white" }}
                            >
                              Shazil Saleem
                            </Typography>
                          </Grid>
                        </div>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </SwiperSlide>
          </Swiper>
        </Grid>
      </section>
    </>
  );
};

const CustomCard = ({ images, title, description }) => {
  const [hovered, setHovered] = useState(false);

  const settings = {
    dots: true,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: true,
    speed: 3000,
    autoplaySpeed: 2000,
    cssEase: "linear",
  };

  return (
    <div
      className={styles.custom_card}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index}>
            <img
              src={image}
              alt={`Image ${index}`}
              className={styles.card_image}
            />
          </div>
        ))}
      </Slider>

      <div className={styles.card_content}>
        <Typography
          variant="h4"
          component="h4"
          style={{
            display: "inline",
            background: "-webkit-linear-gradient(left, #ff8a00, #e52e71)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          <strong>{title}</strong>{" "}
        </Typography>

        {/* <p className={styles.card_description}>{description}</p> */}
      </div>
    </div>
  );
};

const FineModels = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const images = [forestGirl, biker, villian];
  const images2 = [motherDay, boyWriting, boyAndGirl];
  const images3 = [creator, painter, familyDay];
  const images4 = [investigating, superHeroes, power];

  return (
    <>
      <section
        className="coming-soon"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <Typography
         className={styles.model_heading}
          style={{
            display: "inline",
            background: "-webkit-linear-gradient(left, #ff8a00, #e52e71)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          <strong className={textStyles.model_heading}>Fine-tuned Models for Comic Creation</strong>{" "}
        </Typography>
        <div>
          <Typography className={textStyles.model_description}>
            Supporting your creative journey, from concept to completion
          </Typography>
        </div>
      </section>
      {/* Integration of CustomCard component */}
      <Container>
        <Grid container justifyContent="center" spacing={2}>
          <Swiper
            style={{
              "--swiper-navigation-color": "#fff",
              "--swiper-pagination-color": "#fff",
            }}
            spaceBetween={10}
            navigation={true}
            thumbs={{ swiper: thumbsSwiper }}
            modules={[FreeMode, Navigation, Thumbs]}
            className="mySwiper2"
          >
            <SwiperSlide>
              <Grid item lg={12}>
                <CustomCard
                  images={images}
                  title="MANGA"
                  description="Custom Card Description"
                />
              </Grid>
            </SwiperSlide>
            <SwiperSlide>
              <CustomCard
                images={images2}
                title="WEB COMIC"
                description="Custom Card Description"
              />
            </SwiperSlide>
            <SwiperSlide>
              <CustomCard
                images={images3}
                title="CARTOON"
                description="Custom Card Description"
              />
            </SwiperSlide>
            <SwiperSlide>
              <CustomCard
                images={images4}
                title="COMIC"
                description="Custom Card Description"
              />
            </SwiperSlide>
          </Swiper>
        </Grid>
      </Container>
      {/* <Container className={styles.model_Container}>
        <Grid
          container
          spacing={0}
          style={{
            width: "100%",
            marginLeft: "0",
            paddingLeft: "4rem",
            paddingRight: "4rem",
          }}
        >
          <Grid
            lg={3}
            md={6}
            style={{ display: "flex", justifyContent: "center" }}
          ></Grid>
          <Grid
            lg={3}
            md={6}
            style={{ display: "flex", justifyContent: "center" }}
          ></Grid>
          <Grid
            lg={3}
            md={6}
            style={{ display: "flex", justifyContent: "center" }}
          ></Grid>
          <Grid
            lg={3}
            md={6}
            style={{ display: "flex", justifyContent: "center" }}
          ></Grid>
        </Grid>
      </Container> */}
    </>
  );
};

export default FineModels;
